// extracted by mini-css-extract-plugin
module.exports = {"button":"CarouselButton_button__2bEua","focused":"CarouselButton_focused__ySmYz"};